export default __webpack_public_path__ + "static/media/TrainStation.256.e9a8c03e.png";